export class UserVO {
    public id: number;
    public username: string;
    public password: string;
    public firstname: string;
    public lastname: string;
    public companyid: number;
    public usertype: string;
    public addressId: number;
    public exportCompanyid:number;

    constructor(id: number, u: string, p: string, fn: string, ln: string, cid: number, ut: string, ai: number) {
        this.id = id;
        this.username = u;
        this.password = p;
        this.firstname = fn;
        this.lastname = ln;
        this.companyid = cid;
        this.usertype = ut;
        this.addressId = ai;
        
    }
    
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/model/UserVO.ts